// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createHook,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import type { State, Actions, Props } from './types.tsx';

const initialState: State = {
	isAITourEnabled: false,
};

// Exported for testing
export const Store = createStore<State, Actions, Props>({ initialState, actions });

export const Container = createContainer<State, Actions, Props>(Store, {
	onInit:
		() =>
		({ setState }, { isAITourUserPreferenceEnabled }) => {
			setState({
				isAITourEnabled: isAITourUserPreferenceEnabled,
			});
		},
});

export const useIsAITourEnabled = createHook(Store, {
	selector: (state) => state.isAITourEnabled,
});

export const useAITourActions = createActionsHook(Store);
